import React from 'react'

import AdCopyIcon from './components/AdCopyIcon'
import AerialIcon from './components/AerialIcon'
import BundlesIcon from './components/BundlesIcon'
import DesignIcon from './components/DesignIcon'
import DigitalIcon from './components/DigitalIcon'
import FavouritesIcon from './components/FavouritesIcon'
import LightboardsIcon from './components/LightboardsIcon'
import NewspaperIcon from './components/NewspaperIcon'
import OtherIcon from './components/OtherIcon'
import PackagesIcon from './components/PackagesIcon'
import PhotographyIcon from './components/PhotographyIcon'
import PlansIcon from './components/PlansIcon'
import PrintIcon from './components/PrintIcon'
import ProposalIcon from './components/ProposalIcon'
import SignboardsIcon from './components/SignboardsIcon'
import SocialMediaIcon from './components/SocialMediaIcon'
import StationeryIcon from './components/StationeryIcon'
import StockboardsIcon from './components/StockboardsIcon'
import VideoIcon from './components/VideoIcon'

const serviceIcons = {
  adcopy: AdCopyIcon,
  aerial: AerialIcon,
  bundles: BundlesIcon,
  design: DesignIcon,
  digital: DigitalIcon,
  editorial: NewspaperIcon,
  favourites: FavouritesIcon,
  lightboards: LightboardsIcon,
  newspaper: NewspaperIcon,
  'newspaper-manual': NewspaperIcon,
  other: OtherIcon,
  packages: PackagesIcon,
  photography: PhotographyIcon,
  plans: PlansIcon,
  print: PrintIcon,
  'print-bulk': PrintIcon,
  'print-premium': PrintIcon,
  proposal: ProposalIcon,
  quotes: ProposalIcon,
  signboards: SignboardsIcon,
  'social-media': SocialMediaIcon,
  stationery: StationeryIcon,
  stockboards: StockboardsIcon,
  video: VideoIcon,
} as const

type ServiceIconKey = keyof typeof serviceIcons

interface ServiceIconProps {
  className?: string,
  fallbackIcon?: React.ReactNode,
  fillColor: string,
  height: number | string,
  serviceKey: ServiceIconKey,
  width: number | string,
}

const ServiceIcon = (props: ServiceIconProps) => {
  const {
    className,
    fallbackIcon,
    fillColor = '#000000',
    height,
    serviceKey,
    width,
  } = props

  const IconComponent = serviceIcons[serviceKey]
  if (IconComponent){
    return (
      <IconComponent
        className={className}
        fillColor={fillColor}
        height={height}
        width={width}
      />
    )
  }

  return fallbackIcon || null
}

export default ServiceIcon
